// AVRASTRO logo components (assets in brand-assets.ts).
import { VERO_LOGO_2X, VERO_MARK, VERO_WORDMARK } from './brand-assets.ts';
export { VERO_LOGO, VERO_LOGO_2X, VERO_MARK, VERO_WORDMARK } from './brand-assets.ts';

/** The A-mark (app shell, lock screen, small placements). */
export function VeroMark({ size = 30, className = '' }: { size?: number; className?: string }) {
  return <img className={`vero-mark ${className}`} src={VERO_MARK} alt="" aria-hidden="true" style={{ height: size, width: 'auto' }} draggable={false} />;
}
/** Full logo (mark + wordmark) for welcome, sign-in, onboarding and account screens. */
export function VeroLogo({ width = 150, className = '' }: { width?: number; className?: string }) {
  return <img className={`vero-logo ${className}`} src={VERO_LOGO_2X} alt="AVRASTRO" style={{ width, height: 'auto' }} draggable={false} />;
}
/** Wordmark only (“AVRASTRO”), e.g. next to the mark in the top bar. */
export function VeroWordmark({ height = 13, className = '' }: { height?: number; className?: string }) {
  return <img className={`vero-wordmark ${className}`} src={VERO_WORDMARK} alt="AVRASTRO" style={{ height, width: 'auto' }} draggable={false} />;
}
